<span class="modal-close-icon"><i class="fa-regular fa-circle-xmark" (click)="closeModal('dismiss')"></i></span>
<div class="modal-body">
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12">
      <form [formGroup]="relayBoardForm">
        <div class="mt-5">
          <div class="form-row">
            <div class="col-md-3 mb-3">
              <label for="name">Name</label>
              <input type="text" class="form-control" formControlName="name" id="name" placeholder="Name">
            </div>
            <div class="col-md-2 mb-3">
              <label for="relayCount">Relays Count</label>
              <input type="text" class="form-control" formControlName="relayCount" id="relayCount" placeholder="relayCount">
            </div>
            <div class="col-md-3 mb-3">
              <label for="officeId">Office</label>
              <select id="officeId" class="form-control" formControlName="officeId">
                <option *ngFor="let office of offices" [value]="office.id">
                  {{ office.city + ', ' + office.address }}
                </option>
              </select>
            </div>
            <div class="col-md-3 mb-3">
              <label for="host">Host</label>
              <input type="text" class="form-control" formControlName="host" id="host" placeholder="Host">
            </div>
            <div class="col-md-1 mb-3">
              <label for="port">Port</label>
              <input type="text" class="form-control" formControlName="port" id="port" placeholder="Port">
            </div>
          </div>
          <div class="modal-buttons text-center">
            <button type="button" class="btn btn-default add-edit-button" (click)="closeModal(relayBoardForm)">Save</button>
            <button type="button" class="btn btn-light cancel-button" (click)="closeModal('cancel')">Cancel</button>
          </div>
          <div class="form-row mt-4">
            <div class="alert alert-danger" *ngIf="errorMessage">Error: {{errorMessage}}</div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
